import ghanaLogo from "../../assets/images/Logo/transparency background/Little Haiti Global-08.png";

export default function LogoContainer() {
  return (
    <div className="logoContainer">
      <div className="logoContent">
        <img
          src={ghanaLogo}
          alt="Global"
          className="logoImage"
          style={styles.logoImage}
        />
        <h2 style={styles.logoTitle}>LHG E-Portal</h2>
      </div>
    </div>
  );
}
const styles = {
  logoImage: {
    width: "100%",
    maxWidth: "500px",
    height: "280px",
    objectFit: "contain",
    marginBottom: "10px",
  },
  logoTitle: {
    fontWeight: "bold",
    color: "#fec013",
    marginBottom: "10px",
    fontSize: "30px",
  },
  logoSubtitle: {
    fontSize: "1.5rem",
    color: "#555",
    fontWeight: "normal",
  },
  formContainer: {
    flex: 1.4, // Increased from 1 to make right side wider
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px",
    backgroundColor: "#f5f5f5",
  },
  formContent: {
    width: "100%",
    maxWidth: "400px",
  },
  signInTitle: {
    fontSize: "1.8rem",
    fontWeight: "bold",
    marginBottom: "30px",
    color: "#333",
  },
  form: {
    width: "100%",
  },
  formGroup: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "500",
    color: "#333",
  },
  input: {
    width: "100%",
    padding: "12px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "16px",
    boxSizing: "border-box",
  },
  visibilityToggle: {
    position: "absolute",
    right: "10px",
    top: "38px",
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#666",
  },
  forgotPasswordContainer: {
    textAlign: "right",
    marginBottom: "20px",
  },
  forgotPasswordLink: {
    color: "#0066cc",
    textDecoration: "none",
    fontSize: "14px",
  },
  submitButton: {
    width: "100%",
    padding: "14px",
    backgroundColor: "#006F32",
    color: "white",
    border: "none",
    borderRadius: "4px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    marginBottom: "20px",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "#005999",
    },
  },
  signUpContainer: {
    textAlign: "center",
    marginTop: "20px",
  },
  signUpText: {
    color: "#555",
    marginBottom: "8px",
  },
  signUpLink: {
    color: "#0071bc",
    textDecoration: "none",
    fontWeight: "bold",
  },
};
